import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/components/Index'
import Login from '@/components/Login'
import Register from '@/components/Register'
import Forgetpass from '@/components/Forgetpass'
import Products from '@/components/Products'
import Expert from '@/components/Expert'
import ExpertCont from '@/components/ExpertCont'
import News from '@/components/News'
import NewsCont from '@/components/NewsCont'
import About from '@/components/About'
import Aboutlx from '@/components/Aboutlx'
import Aboutdy from '@/components/Aboutdy'
import ProductsCont from '@/components/ProductsCont'
import CompanyAbout from '@/components/CompanyAbout'
import Member from '@/components/Member'
import MemberInfo from '@/components/MemberInfo'
import MemberInfoedit from '@/components/MemberInfoedit'
import MemberNews from '@/components/MemberNews'
import MemberNewsAdd from '@/components/MemberNewsAdd'
import MemberNewsEdit from '@/components/MemberNewsEdit'  //  新闻修改详情
import Forum from '@/components/Forum'  // 论坛
import MemberAppraise from '@/components/MemberAppraise'  // 评价
import MemberPassword from '@/components/MemberPassword'  // 修改密码
import MemberAbout from '@/components/MemberAbout'  // 修改密码
import MemberEnterprise from '@/components/MemberEnterprise'  // 企业完善信息
import MemberProduct from '@/components/MemberProduct'  // 图文添加信息
import MemberProductAdd from '@/components/MemberProductAdd'  // 图文添加信息
import MemberProductEdit from '@/components/MemberProductEdit'  //  图文修改详情
import MemberIntegral from '@/components/MemberIntegral'  // 我的积分
import MemberIntegraljb from '@/components/MemberIntegraljb'  // 我的积分
import Jobs from '@/components/Jobs'  // 论坛
import JobsCont from '@/components/JobsCont'  // 论坛详情
import Aboutgg from '@/components/Aboutgg'  // 论坛详情
import Qiyelist from '@/components/Qiyelist'  // 企业展示
import MemberZh from '@/components/MemberZh'  // 企业展示

import Goodscart from '@/components/Goodscart'  // 购物车
import Orderlist from '@/components/Orderlist'  // 订单列表
import Tlpro from '@/components/Tlpro'  // 同类图书馆
import Booklist from '@/components/Booklist'  // 目录列表
import TlproCont from '@/components/TlproCont'  // 同类图书馆详情
import Book from '@/components/Book'  // 目录列表
import Bookcont from '@/components/Bookcont'  // 书籍详情
import Cglist from '@/components/Cglist'  // 采购列表

import AboutCont from '@/components/AboutCont'  // 同类图书馆详情


Vue.use(Router)
export default new Router({
  scrollBehavior(to,from,savedPosition){

    if (savedPosition){

    return savedPosition // 按下 后退/前进 按钮时，类似浏览器的原生表现

    }else {

    return {x:0,y:0} // 让页面滚动到顶部

    }

    },
  // mode:'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/HelloWorld',
      component: HelloWorld,
    },
    {
      path: '/Index',
      component: Index,
	  meta:{
	    auth:true
	  }
    },
    {
      path: '/Goodscart',
      component: Goodscart,
      meta:{
        auth:true
      }
    },
    {
      path: '/Cglist',
      component: Cglist,
      meta:{
        auth:true
      }
    },
    {
      path: '/Orderlist',
      component: Orderlist,
      meta:{
        auth:true
      }
    },
    {
      path: '/Tlpro',
      component: Tlpro,
      meta:{
        auth:true
      }
    },
    {
      path: '/TlproCont',
      component: TlproCont,
      meta:{
        auth:true
      }
    },
    {
      path: '/AboutCont',
      component: AboutCont,
      meta:{
        auth:true
      }
    },
    {
      path: '/Booklist',
      component: Booklist,
      meta:{
        auth:true
      }
    },
    {
      path: '/Book',
      component: Book,
      meta:{
        auth:true
      }
    },
    {
      path: '/Bookcont',
      component: Bookcont,
      meta:{
        auth:true
      }
    },
    {
      path: '/Register',
      component: Register,
    },
    {
      path: '/Forgetpass',
      component: Forgetpass,
    },
    {
      path: '/Products',
      component: Products,
    },
    {
      path: '/Expert',
      component: Expert,
    },
    {
      path: '/ExpertCont',
      component: ExpertCont,
    },
    {
      path: '/News',
      component: News,
    },
    {
      path: '/NewsCont',
      component: NewsCont,
    },
	{
	  path: '/Qiyelist',
	  component: Qiyelist,
	},

    {
      path: '/About',
      component: About,
    },
    {
      path: '/Aboutlx',
      component: Aboutlx,
    },
    {
      path: '/Aboutdy',
      component: Aboutdy,
    },
    {
      path: '/ProductsCont',
      component: ProductsCont,
    },
    {
      path: '/CompanyAbout',
      component: CompanyAbout,
    },
    {
      path: '/Member',
      component: Member,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberInfo',
      component: MemberInfo,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberInfoedit',
      component: MemberInfoedit,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberNews',
      component: MemberNews,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberNews',
      component: MemberNews,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberNewsAdd',
      component: MemberNewsAdd,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberNewsEdit',
      component: MemberNewsEdit,
      meta:{
        auth:true
      }
    },
    {
      path: '/Forum',
      component: Forum,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberAppraise',
      component: MemberAppraise,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberPassword',
      component: MemberPassword,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberZh',
      component: MemberZh,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberAbout',
      component: MemberAbout,
    },
    {
      path: '/MemberEnterprise',
      component: MemberEnterprise,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberProduct',
      component: MemberProduct,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberProductAdd',
      component: MemberProductAdd,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberProductEdit',
      component: MemberProductEdit,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberIntegral',
      component: MemberIntegral,
      meta:{
        auth:true
      }
    },
    {
      path: '/MemberIntegraljb',
      component: MemberIntegraljb,
      meta:{
        auth:true
      }
    },
    {
      path: '/Jobs',
      component: Jobs,
    },
    {
      path: '/JobsCont',
      component: JobsCont,
    },
    {
      path: '/Aboutgg',
      component: Aboutgg,
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js